import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EditSetupComponent } from './edit-setup.component';
import { PermissionsGuard } from 'src/app/shared/guards/permissions.guard';
import { SettingModule } from '../components/setting-module/setting-module.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

const routes: Routes = [
  {
    path: ':id',
    component: EditSetupComponent,
    children: [
      {
        path: 'module/:moduleId',
        title: 'Configurar Módulo',
        loadChildren: () => SettingModule,
        canActivate: [PermissionsGuard]
      }
    ]

  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule  
  ]
})
export class EditSetupRoutingModule { }
